import { apiFetch, getApiUrl, readStoredAuthToken } from './api';

export const BACKUP_FILTER_OPTIONS = [
  { value: 'all', label: 'All Data' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' },
  { value: 'yearly', label: 'Yearly' },
  { value: 'custom', label: 'Custom Date Range' },
];

export const DEFAULT_BACKUP_FILTER = Object.freeze({
  filterType: 'all',
  startDate: '',
  endDate: '',
});

function buildQueryString(filters = DEFAULT_BACKUP_FILTER) {
  const filterType = String(filters?.filterType || 'all').trim().toLowerCase();
  const params = new URLSearchParams();

  params.set('filterType', filterType || 'all');

  if (filterType === 'custom') {
    if (filters?.startDate) {
      params.set('startDate', filters.startDate);
    }
    if (filters?.endDate) {
      params.set('endDate', filters.endDate);
    }
  }

  const query = params.toString();
  return query ? `?${query}` : '';
}

function extractErrorMessage(text, status) {
  if (!text) {
    return `Request failed with status ${status}`;
  }

  try {
    const payload = JSON.parse(text);
    return payload?.message || payload?.error || `Request failed with status ${status}`;
  } catch (error) {
    return text.split('\n')[0].trim() || `Request failed with status ${status}`;
  }
}

function getFileNameFromDisposition(value) {
  if (!value) {
    return '';
  }

  const utf8Match = value.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match) {
    return decodeURIComponent(utf8Match[1]);
  }

  const standardMatch = value.match(/filename="?([^"]+)"?/i);
  return standardMatch ? standardMatch[1] : '';
}

async function downloadBlob(path) {
  const headers = new Headers();
  const token = readStoredAuthToken();

  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  const response = await fetch(getApiUrl(path), {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(extractErrorMessage(text, response.status));
  }

  const blob = await response.blob();
  const fileName = getFileNameFromDisposition(response.headers.get('content-disposition')) || 'myloancrm-backup.xlsx';
  return { blob, fileName };
}

export async function getBackupSnapshot(filters = DEFAULT_BACKUP_FILTER) {
  const payload = await apiFetch(`/api/backup/snapshot${buildQueryString(filters)}`);
  return payload?.data || null;
}

export async function downloadBackupWorkbook(filters = DEFAULT_BACKUP_FILTER) {
  const { blob, fileName } = await downloadBlob(`/api/backup/download${buildQueryString(filters)}`);
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = objectUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);

  return { fileName };
}
